export const serviceReceiveAuth = [
    {value: false, text: "비활성화"},
    {value: true, text: "활성화", red: true},
];

export const emailReceiveAuth = [
    {value: false, text: "거부"},
    {value: true, text: "동의", red: true},
];
